import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faArrowAltFromBottom        as farArrowAltFromBottom,
  faComment                   as farComment,
  faTrashAlt                  as farTrashAlt,
  faEllipsisH                 as farEllipsisH,
  faSearch                    as farSearch,
  faSpinner                   as farSpinner,
  faAlarmClock                as farAlarmClock,
  faAmbulance                 as farAmbulance,
  faAnchor                    as farAnchor,
  faArchive                   as farArchive,
  faAppleAlt                  as farAppleAlt,
  faAssistiveListeningSystems as farAssistiveListeningSystems,
  faAsterisk                  as farAsterisk,
  faAt                        as farAt,
  faAtom                      as farAtom,
  faAward                     as farAward,
  faBackpack                  as farBackpack,
  faBadgeCheck                as farBadgeCheck,
  faBars                      as farBars,
  faBaseball                  as farBaseball,
  faBasketballHoop            as farBasketballHoop,
  faBell                      as farBell,
  faBicycle                   as farBicycle,
  faBinoculars                as farBinoculars,
  faBirthdayCake              as farBirthdayCake,
  faBolt                      as farBolt,
  faBook                      as farBook,
  faBooks                     as farBooks,
  faBraille                   as farBraille,
  faBriefcase                 as farBriefcase,
  faBuilding                  as farBuilding,
  faBullseye                  as farBullseye,
  faBusSchool                 as farBusSchool,
  faCalculator                as farCalculator,
  faCalendar                  as farCalendar,
  faCameraAlt                 as farCameraAlt,
  faCheck                     as farCheck,
  faClock                     as farClock,
  faCode                      as farCode,
  faCoffee                    as farCoffee,
  faCompass                   as farCompass,
  faCreditCard                as farCreditCard,
  faCube                      as farCube,
  faDeaf                      as farDeaf,
  faDesktopAlt                as farDesktopAlt,
  faDollarSign                as farDollarSign,
  faDoorOpen                  as farDoorOpen,
  faExclamationTriangle       as farExclamationTriangle,
  faEye                       as farEye,
  faEyeDropper                as farEyeDropper,
  faFighterJet                as farFighterJet,
  faFlagCheckered             as farFlagCheckered,
  faFlask                     as farFlask,
  faFootballBall              as farFootballBall,
  faFrog                      as farFrog,
  faFutbol                    as farFutbol,
  faGamepad                   as farGamepad,
  faGavel                     as farGavel,
  faGem                       as farGem,
  faGift                      as farGift,
  faGolfBall                  as farGolfBall,
  faGraduationCap             as farGraduationCap,
  faGripLines                 as farGripLines,
  faHeadphones                as farHeadphones,
  faInboxIn                   as farInboxIn,
  faIndustryAlt               as farIndustryAlt,
  faJackOLantern              as farJackOLantern,
  faKey                       as farKey,
  faKeyboard                  as farKeyboard,
  faLandmark                  as farLandmark,
  faLeaf                      as farLeaf,
  faLemon                     as farLemon,
  faLifeRing                  as farLifeRing,
  faLightbulb                 as farLightbulb,
  faLocationArrow             as farLocationArrow,
  faLockAlt                   as farLockAlt,
  faMagic                     as farMagic,
  faMagnet                    as farMagnet,
  faMapSigns                  as farMapSigns,
  faMedkit                    as farMedkit,
  faMegaphone                 as farMegaphone,
  faMicrophoneAlt             as farMicrophoneAlt,
  faMinusCircle               as farMinusCircle,
  faMobileAlt                 as farMobileAlt,
  faMoneyBill                 as farMoneyBill,
  faMoon                      as farMoon,
  faMotorcycle                as farMotorcycle,
  faMusic                     as farMusic,
  faNewspaper                 as farNewspaper,
  faPaintBrush                as farPaintBrush,
  faPaperPlane                as farPaperPlane,
  faPaperclip                 as farPaperclip,
  faPaw                       as farPaw,
  faPenAlt                    as farPenAlt,
  faPencilAlt                 as farPencilAlt,
  faPiggyBank                 as farPiggyBank,
  faPlaneAlt                  as farPlaneAlt,
  faPlug                      as farPlug,
  faPlus                      as farPlus,
  faPodium                    as farPodium,
  faPuzzlePiece               as farPuzzlePiece,
  faRoad                      as farRoad,
  faRocket                    as farRocket,
  faRulerTriangle             as farRulerTriangle,
  faShieldAlt                 as farShieldAlt,
  faShip                      as farShip,
  faSmile                     as farSmile,
  faSnowflake                 as farSnowflake,
  faSpaceShuttle              as farSpaceShuttle,
  faSpade                     as farSpade,
  faStar                      as farStar,
  faTaxi                      as farTaxi,
  faTheaterMasks              as farTheaterMasks,
  faThermometerHalf           as farThermometerHalf,
  faTicketAlt                 as farTicketAlt,
  faTree                      as farTree,
  faTrophyAlt                 as farTrophyAlt,
  faTruck                     as farTruck,
  faTvRetro                   as farTvRetro,
  faUmbrellaBeach             as farUmbrellaBeach,
  faUniversity                as farUniversity,
  faUserAstronaut             as farUserAstronaut,
  faUserCog                   as farUserCog,
  faUserGraduate              as farUserGraduate,
  faUtensils                  as farUtensils,
  faWatch                     as farWatch,
  faWheelchair                as farWheelchair,
  faWrench                    as farWrench,
} from '@fortawesome/pro-regular-svg-icons'

let regulars = [
  farArrowAltFromBottom,
  farTrashAlt,
  farEllipsisH,
  farSearch,
  farSpinner,
  farAlarmClock,
  farAmbulance,
  farAnchor,
  farArchive,
  farAppleAlt,
  farAssistiveListeningSystems,
  farAsterisk,
  farAt,
  farAtom,
  farAward,
  farBackpack,
  farBadgeCheck,
  farBaseball,
  farBasketballHoop,
  farBars,
  farBell,
  farBicycle,
  farBinoculars,
  farBirthdayCake,
  farBolt,
  farBook,
  farBooks,
  farBraille,
  farBriefcase,
  farBuilding,
  farBullseye,
  farBusSchool,
  farCalculator,
  farCalendar,
  farCameraAlt,
  farCheck,
  farClock,
  farCode,
  farCoffee,
  farComment,
  farCompass,
  farCreditCard,
  farCube,
  farDeaf,
  farDesktopAlt,
  farDollarSign,
  farDoorOpen,
  farExclamationTriangle,
  farEye,
  farEyeDropper,
  farFighterJet,
  farFlagCheckered,
  farFlask,
  farFootballBall,
  farFrog,
  farFutbol,
  farGamepad,
  farGavel,
  farGem,
  farGift,
  farGolfBall,
  farGraduationCap,
  farGripLines,
  farHeadphones,
  farInboxIn,
  farIndustryAlt,
  farJackOLantern,
  farKey,
  farKeyboard,
  farLandmark,
  farLeaf,
  farLemon,
  farLifeRing,
  farLightbulb,
  farLocationArrow,
  farLockAlt,
  farMagic,
  farMagnet,
  farMapSigns,
  farMedkit,
  farMegaphone,
  farMicrophoneAlt,
  farMinusCircle,
  farMobileAlt,
  farMoneyBill,
  farMoon,
  farMotorcycle,
  farMusic,
  farNewspaper,
  farPaintBrush,
  farPaperPlane,
  farPaperclip,
  farPaw,
  farPenAlt,
  farPencilAlt,
  farPiggyBank,
  farPlaneAlt,
  farPlug,
  farPlus,
  farPodium,
  farPuzzlePiece,
  farRoad,
  farRocket,
  farRulerTriangle,
  farShieldAlt,
  farShip,
  farSmile,
  farSnowflake,
  farSpaceShuttle,
  farSpade,
  farStar,
  farTaxi,
  farTheaterMasks,
  farThermometerHalf,
  farTicketAlt,
  farTree,
  farTrophyAlt,
  farTruck,
  farTvRetro,
  farUmbrellaBeach,
  farUniversity,
  farUserAstronaut,
  farUserCog,
  farUserGraduate,
  farUtensils,
  farWatch,
  farWheelchair,
  farWrench,
]

import {
  faAssistiveListeningSystems as fasAssistiveListeningSystems,
  faPlus                      as fasPlus,
  faEllipsisH                 as fasEllipsisH,
  faCheckCircle               as fasCheckCircle,
  faPlusCircle                as fasPlusCircle,
  faCaretDown                 as fasCaretDown,
  faCaretUp                   as fasCaretUp,
  faComment                   as fasComment,
  faTrash                     as fasTrash,
  faEdit                      as fasEdit,
  faBullhorn                  as fasBullhorn,
  faCheck                     as fasCheck,
  faBirthdayCake              as fasBirthdayCake,
  faAlarmClock                as fasAlarmClock,
  faAmbulance                 as fasAmbulance,
  faAnchor                    as fasAnchor,
  faArchive                   as fasArchive,
  faAppleAlt                  as fasAppleAlt,
  faAsterisk                  as fasAsterisk,
  faAt                        as fasAt,
  faAtom                      as fasAtom,
  faAward                     as fasAward,
  faBackpack                  as fasBackpack,
  faBadgeCheck                as fasBadgeCheck,
  faBan                       as fasBan,
  faBars                      as fasBars,
  faBaseball                  as fasBaseball,
  faBasketballHoop            as fasBasketballHoop,
  faBell                      as fasBell,
  faBicycle                   as fasBicycle,
  faBinoculars                as fasBinoculars,
  faBolt                      as fasBolt,
  faBook                      as fasBook,
  faBooks                     as fasBooks,
  faBraille                   as fasBraille,
  faBriefcase                 as fasBriefcase,
  faBuilding                  as fasBuilding,
  faBullseye                  as fasBullseye,
  faBusSchool                 as fasBusSchool,
  faCalculator                as fasCalculator,
  faCalendar                  as fasCalendar,
  faCameraAlt                 as fasCameraAlt,
  faChevronDown               as fasChevronDown,
  faClock                     as fasClock,
  faCode                      as fasCode,
  faCoffee                    as fasCoffee,
  faCompass                   as fasCompass,
  faCreditCard                as fasCreditCard,
  faCube                      as fasCube,
  faDeaf                      as fasDeaf,
  faDesktopAlt                as fasDesktopAlt,
  faDollarSign                as fasDollarSign,
  faDoorOpen                  as fasDoorOpen,
  faExclamationTriangle       as fasExclamationTriangle,
  faEye                       as fasEye,
  faEyeDropper                as fasEyeDropper,
  faFighterJet                as fasFighterJet,
  faFlagCheckered             as fasFlagCheckered,
  faFlask                     as fasFlask,
  faFootballBall              as fasFootballBall,
  faFrog                      as fasFrog,
  faFutbol                    as fasFutbol,
  faGamepad                   as fasGamepad,
  faGavel                     as fasGavel,
  faGem                       as fasGem,
  faGift                      as fasGift,
  faGolfBall                  as fasGolfBall,
  faGraduationCap             as fasGraduationCap,
  faHeadphones                as fasHeadphones,
  faInboxIn                   as fasInboxIn,
  faIndustryAlt               as fasIndustryAlt,
  faJackOLantern              as fasJackOLantern,
  faKey                       as fasKey,
  faKeyboard                  as fasKeyboard,
  faLandmark                  as fasLandmark,
  faLeaf                      as fasLeaf,
  faLemon                     as fasLemon,
  faLifeRing                  as fasLifeRing,
  faLightbulb                 as fasLightbulb,
  faLocationArrow             as fasLocationArrow,
  faLockAlt                   as fasLockAlt,
  faMagic                     as fasMagic,
  faMagnet                    as fasMagnet,
  faMapSigns                  as fasMapSigns,
  faMedkit                    as fasMedkit,
  faMegaphone                 as fasMegaphone,
  faMicrophoneAlt             as fasMicrophoneAlt,
  faMobileAlt                 as fasMobileAlt,
  faMoneyBill                 as fasMoneyBill,
  faMoon                      as fasMoon,
  faMotorcycle                as fasMotorcycle,
  faMusic                     as fasMusic,
  faNewspaper                 as fasNewspaper,
  faPaintBrush                as fasPaintBrush,
  faPaperPlane                as fasPaperPlane,
  faPaperclip                 as fasPaperclip,
  faPaw                       as fasPaw,
  faPenAlt                    as fasPenAlt,
  faPencilAlt                 as fasPencilAlt,
  faPiggyBank                 as fasPiggyBank,
  faPlaneAlt                  as fasPlaneAlt,
  faPlug                      as fasPlug,
  faPodium                    as fasPodium,
  faPuzzlePiece               as fasPuzzlePiece,
  faRoad                      as fasRoad,
  faRocket                    as fasRocket,
  faRulerTriangle             as fasRulerTriangle,
  faShieldAlt                 as fasShieldAlt,
  faShip                      as fasShip,
  faSmile                     as fasSmile,
  faSnowflake                 as fasSnowflake,
  faSpaceShuttle              as fasSpaceShuttle,
  faSpade                     as fasSpade,
  faStar                      as fasStar,
  faTaxi                      as fasTaxi,
  faTheaterMasks              as fasTheaterMasks,
  faThermometerHalf           as fasThermometerHalf,
  faTicketAlt                 as fasTicketAlt,
  faTimes                     as fasTimes,
  faTimesCircle               as fasTimesCircle,
  faTree                      as fasTree,
  faTrophyAlt                 as fasTrophyAlt,
  faTruck                     as fasTruck,
  faTvRetro                   as fasTvRetro,
  faUmbrellaBeach             as fasUmbrellaBeach,
  faUniversity                as fasUniversity,
  faUserAstronaut             as fasUserAstronaut,
  faUserGraduate              as fasUserGraduate,
  faUtensils                  as fasUtensils,
  faWatch                     as fasWatch,
  faWheelchair                as fasWheelchair,
  faWrench                    as fasWrench,
} from '@fortawesome/pro-solid-svg-icons'

let solids = [
  fasAssistiveListeningSystems,
  fasPlus,
  fasEllipsisH,
  fasPlusCircle,
  fasCaretDown,
  fasCaretUp,
  fasComment,
  fasTrash,
  fasEdit,
  fasBullhorn,
  fasCheck,
  fasBirthdayCake,
  fasAlarmClock,
  fasAmbulance,
  fasAnchor,
  fasArchive,
  fasAppleAlt,
  fasAsterisk,
  fasAt,
  fasAtom,
  fasAward,
  fasBackpack,
  fasBadgeCheck,
  fasBan,
  fasBars,
  fasBaseball,
  fasBasketballHoop,
  fasBell,
  fasBicycle,
  fasBinoculars,
  fasBolt,
  fasBook,
  fasBooks,
  fasBraille,
  fasBriefcase,
  fasBuilding,
  fasBullseye,
  fasBusSchool,
  fasCalculator,
  fasCalendar,
  fasCameraAlt,
  fasCheckCircle,
  fasChevronDown,
  fasClock,
  fasCode,
  fasCoffee,
  fasCompass,
  fasCreditCard,
  fasCube,
  fasDeaf,
  fasDesktopAlt,
  fasDollarSign,
  fasDoorOpen,
  fasExclamationTriangle,
  fasEye,
  fasEyeDropper,
  fasFighterJet,
  fasFlagCheckered,
  fasFlask,
  fasFootballBall,
  fasFrog,
  fasFutbol,
  fasGamepad,
  fasGavel,
  fasGem,
  fasGift,
  fasGolfBall,
  fasGraduationCap,
  fasHeadphones,
  fasInboxIn,
  fasIndustryAlt,
  fasJackOLantern,
  fasKey,
  fasKeyboard,
  fasLandmark,
  fasLeaf,
  fasLemon,
  fasLifeRing,
  fasLightbulb,
  fasLocationArrow,
  fasLockAlt,
  fasMagic,
  fasMagnet,
  fasMapSigns,
  fasMedkit,
  fasMegaphone,
  fasMicrophoneAlt,
  fasMobileAlt,
  fasMoneyBill,
  fasMoon,
  fasMotorcycle,
  fasMusic,
  fasNewspaper,
  fasPaintBrush,
  fasPaperPlane,
  fasPaperclip,
  fasPaw,
  fasPenAlt,
  fasPencilAlt,
  fasPiggyBank,
  fasPlaneAlt,
  fasPlug,
  fasPodium,
  fasPuzzlePiece,
  fasRoad,
  fasRocket,
  fasRulerTriangle,
  fasShieldAlt,
  fasShip,
  fasSmile,
  fasSnowflake,
  fasSpaceShuttle,
  fasSpade,
  fasStar,
  fasTaxi,
  fasTheaterMasks,
  fasThermometerHalf,
  fasTicketAlt,
  fasTimes,
  fasTimesCircle,
  fasTree,
  fasTrophyAlt,
  fasTruck,
  fasTvRetro,
  fasUmbrellaBeach,
  fasUniversity,
  fasUserAstronaut,
  fasUserGraduate,
  fasUtensils,
  fasWatch,
  fasWheelchair,
  fasWrench,
]

import {
  faBullhorn      as falBullhorn,
  faComment       as falComment,
  faSearch        as falSearch,
  faTimesCircle   as falTimesCircle,
  faUser          as falUser,
  faUsers         as falUsers,
} from '@fortawesome/pro-light-svg-icons'

let lights = [
  falBullhorn,
  falComment,
  falSearch,
  falTimesCircle,
  falUser,
  falUsers,
]

function loadFontAwesomeIcons() {
  library.add(regulars)
  library.add(solids)
  library.add(lights)
}

export default loadFontAwesomeIcons
